import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import createSelectors from '../utils/createSelectors'

interface State {
  firstRender: boolean
  isHidden: boolean
}
interface Action {
  setIsHidden: (isBannerHidden: State['isHidden']) => void
  setFirstRender: (firstRender: State['firstRender']) => void
}

const baseStoreBanner = create<State & Action>()(
  persist(
    (set) => ({
      firstRender: true,
      isHidden: false,
      setIsHidden: (isHidden) => set(() => ({ isHidden: isHidden })),
      setFirstRender: (firstRender) => set(() => ({ firstRender: firstRender }))
    }),
    {
      name: 'banner',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isHidden: state.isHidden,
        firstRender: state.firstRender
      })
    }
  )
)

const useStoreBanner = createSelectors(baseStoreBanner)

export default useStoreBanner
